import a from "styled-components";
import e from "../../utils/colors.js";
import { device as i } from "../../utils/device.js";
const c = a.div`
  display: flex;
  font-family: VIC, Verdana, Helvetica, sans-serif;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;

  @media ${i.isDesktop}, ${i.isTablet} {
    max-width: ${(o) => `${o.$long ? 664 : 350}px`};
  }
`, r = a.label`
  align-self: stretch;
  height: auto;
  font-weight: 600;
  overflow-wrap: break-word;
  color: ${e.blueGrey};
`, d = a(r)`
  color: ${e.red};
  font-weight: 400;
`, s = a.div`
  margin-top: 8px;
  margin-bottom: 8px;
  width: 100%;
  select::-ms-expand {
    display: none;
  }
`, g = a.select`
  width: 100%;
  height: 48px;
  border-radius: 2px;
  outline: 0px !important;
  border: solid 1px ${(o) => o.error && o.$touched ? e.red : e.blueGrey};
  background-color: ${e.white};
  line-height: 1.5em;
  margin: 0;
  font-family: VIC, Verdana, Helvetica, sans-serif;
  color: ${e.blueGrey};
  padding: 8px 28px 8px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  -webkit-appearance: none; /*Removes default chrome and safari style*/
  -moz-appearance: none; /*Removes default style Firefox*/
  background: transparent;
  background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTMgOCI+CiAgICA8cGF0aCBmaWxsPSIjRTM3MTBBIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS4xMzIgMEw2LjUgNC4zMiAxLjg2OCAwIDAgMS44NjIgNi40NiA4IDEzIDEuODYyeiIvPgo8L3N2Zz4=');
  background-repeat: no-repeat;
  /*Position of the background-image*/
  background-position-y: 55%;
  background-position-x: ${(o) => `${o.$long ? 97 : 95}%`};
  font-size: 1rem;
  text-overflow: ellipsis;

  &:focus {
    padding: 7px 28px 8px 15px;
    background-position-x: ${(o) => `${o.$long ? 97.2 : 95.3}%`};
  }

  &:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 ${e.blueGrey};
  }

  //https://codepen.io/maoberlehner/pen/YQBQNj adding placeholder
  &:invalid {
    color: ${e.blueGrey75};
  }

  // Optional select fields fallback.
  &.has-placeholder {
    color: gray;
  }

  &:disabled {
    color: ${e.blueGrey75};
    background-color: ${e.darkGrey10};
    border-color: ${e.blueGrey};
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTMgOCI+CiAgICA8cGF0aCBmaWxsPSIjM0M0QTYwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS4xMzIgMEw2LjUgNC4zMiAxLjg2OCAwIDAgMS44NjIgNi40NiA4IDEzIDEuODYyeiIvPgo8L3N2Zz4=');
    background-repeat: no-repeat;
    /*Position of the background-image*/
    background-position-y: 55%;
    background-position-x: ${(o) => `${o.$long ? 97 : 95}%`};

    &:active,
    &:focus {
      border-color: ${e.blueGrey} !important;
    }
  }

  &:active,
  &:focus {
    border: solid 2px ${e.orange};
  }
`, p = a.option``, m = a.option``;
export {
  c as Container,
  d as ErrorLabel,
  r as Label,
  p as Option,
  m as OptionPlaceholder,
  g as Select,
  s as SelectWrapper
};
